export const STICKY_COLORS: [string, string][] = [
  ['#fbea57', 'Yellow'],
  ['#d1dcfb', 'Blue'],
  ['#ceefc5', 'Green'],
  ['#FFC0CB', 'Pink'],
  ['#D9CAF8', 'Purple'],
  ['#bcbfc3', 'Gray']
];
